import { get } from 'lodash';
import React from 'react';
import BaseFiltroRecurso from '../../base/BaseFiltroRecurso';

class FiltroRecurso extends BaseFiltroRecurso {
  handleSubmit = () => {
    const { buscarRecursos } = this.props;
    const { values } = this.formApi.getState();
    buscarRecursos(values);
    this.toggle();
    this.updateFilterBoxes(values);
  };

  removeFilter() {
    const { filterToRemove, buscarRecursos } = this.props;
    const newValues = { ...this.values };
    delete newValues[filterToRemove];
    this.values = newValues;
    buscarRecursos(this.values);
    this.updateFilterBoxes(this.values);
  }

  componentDidUpdate(prevProps) {
    const { filterToRemove } = this.props;
    const shouldRemoveFilter =
      filterToRemove && prevProps.filterToRemove !== filterToRemove;
    if (shouldRemoveFilter) {
      this.removeFilter();
    }
  }

  updateFilterBoxes = (values) => {
    const { updateFilterBoxes } = this.props;
    const labels = {
      criado_por: 'elaborador',
      status: 'status',
      aplicacao: 'aplicacao',
      nome_requerente: 'nome do requerente',
      id: 'código',
      item: 'código do item'
    };
    const fieldsWithOptions = ['criado_por', 'status', 'aplicacao'];

    const boxes = Object.entries(values).map((entry) => {
      const field = entry[0];
      const value = entry[1];
      const box = { field, label: labels[field] };
      const hasOptions = fieldsWithOptions.find((d) => d === field);
      if (hasOptions) {
        box.value = get(this.state, field).find(
          (d) => +d.value === +value
        ).label;
      } else {
        box.value = value;
      }
      return box;
    });

    const boxesWithValidValues = boxes.filter((d) => d.value);
    updateFilterBoxes(boxesWithValidValues);
  };

  renderFooter() {
    return (
      <React.Fragment>
        <button
          className="btn danger-button mr-3"
          type="button"
          onClick={this.toggle}
        >
          Fechar
        </button>
        <button
          className="btn primary-button mr-1"
          type="button"
          onClick={this.handleSubmit}
        >
          Buscar
        </button>
      </React.Fragment>
    );
  }
}

export default FiltroRecurso;
